import React from "react";
import "./Home.css";
import Navbar from "../../components/navbar/Navbar";
// import Header from "../../components/header/Header";
import Content from "../../content/Content";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";

const Home = () => {
  return (
    <section className="home">
      {/* <TitleBar/>
      <NavMenu/> */}
      <nav className="ho-nav">
        {/* <Navbar /> */}
        <div className="ho-navpage">
          <Content />
        </div>
    
      </nav>
    </section>
  );
};

export default Home;

